import { Component } from '@wordpress/element';
import { __ } from '@wordpress/i18n';

import { WPLE_API } from './api/request';

import { Modal, Segmented, List, Button } from 'antd';

import { CloseOutlined } from '@ant-design/icons';

import WpleBasicDetails from './components/basic-details';
import WpleOrderStatus from './components/order-status';
import WpleDownload from './components/download-ssl';

class WPLE_Certpanel extends Component {
  constructor() {
    super(...arguments);

    //defaults
    this.state = {
      apiLive: true,
      step: 1,
      approverEmail: '',
      orderID: '',
      activeTab: 'generate',
      myOrders: [],
      resumedOrder: false,
      existingOrdersLoading: true,
    };
  }

  componentDidMount() {
    //check API status

    WPLE_API('status', {}).then((res) => {
      if (res.error) {
        Modal.warning({
          title: 'WP Encryption API Undergoing Maintenance',
          content: 'Please check back after some time.',
        });
        this.setState({
          apiLive: false,
        });
      }
    });

    WPLE_API('getordersupdatestatus', {}).then((orderList) => {
      orderList = orderList.success;

      let newList = [];
      for (const item of orderList) {
        let newObj = {
          title: item.domain,
          status: item.status,
          orderid: item.orderid,
        };
        newList.push(newObj);
      }

      this.setState({ myOrders: newList, existingOrdersLoading: false });
    });
  }

  resumeOrder = (orderID, status) => {
    this.setState({ activeTab: 'generate', resumedOrder: true });

    if (status.toLowerCase() === 'ordered') {
      this.setOrderID(orderID);
      this.setTheStep(2);
    } else if (status.toLowerCase() === 'pending') {
      this.setOrderID(orderID);
      this.setTheStep(2);
    } else if (status.toLowerCase() === 'active') {
      this.setOrderID(orderID);
      this.setTheStep(3);
    } else {
      notification.open({
        message: 'Error!',
        description:
          'Something went wrong. Please contact support@wpencryption.com',
        duration: 20,
      });
    }
  };

  setTheStep = (val) => {
    this.setState({ step: val });
  };

  setApprover = (mail) => {
    this.setState({ approverEmail: mail });
  };

  setOrderID = (ID) => {
    this.setState({ orderID: ID });
  };

  render() {
    const {
      apiLive,
      step,
      approverEmail,
      orderID,
      activeTab,
      myOrders,
      resumedOrder,
      existingOrdersLoading,
    } = this.state;

    return (
      <>
        <h2>WP Encryption Cert Panel</h2>
        <h3>
          You can generate new premium annual SSL certificate valid for an year
          or retrieve existing certificate orders here.{' '}
          <a href="https://wpencryption.com/introducing-wpencryption-certpanel/">
            Tutorial Link
          </a>
          .
        </h3>

        <Segmented
          block
          options={[
            {
              label: (
                <div>
                  <strong>Generate New SSL Certificate</strong>
                </div>
              ),
              value: 'generate',
            },
            {
              label: (
                <div>
                  <strong>Retrieve Existing SSL Orders</strong>
                </div>
              ),
              value: 'retrieve',
            },
          ]}
          value={activeTab}
          onChange={(val) => this.setState({ activeTab: val })}
        />
        <br />
        <br />

        {resumedOrder && activeTab === 'generate' && (
          <div style={{ textAlign: 'center' }}>
            <Button
              shape="circle"
              icon={<CloseOutlined />}
              onClick={() =>
                this.setState({
                  resumedOrder: false,
                  step: 1,
                  orderID: '',
                })
              }
            />
          </div>
        )}

        {apiLive === true ? (
          activeTab === 'generate' ? (
            step === 1 ? (
              <WpleBasicDetails
                tab={activeTab}
                nextStep={this.setTheStep}
                setApproverEmail={this.setApprover}
                setOrderID={this.setOrderID}
              />
            ) : step === 2 ? (
              <WpleOrderStatus
                orderid={orderID}
                approver={approverEmail}
                nextStep={this.setTheStep}
              />
            ) : (
              <WpleDownload orderid={orderID} />
            )
          ) : (
            <List
              className="wpen-certs-list"
              loading={existingOrdersLoading}
              itemLayout="horizontal"
              //loadMore={loadMore}
              dataSource={myOrders}
              renderItem={(item) => (
                <List.Item
                  actions={[
                    //<a key="cert-item-resume">edit</a>,
                    (item.status.toLowerCase() === 'pending' ||
                      item.status.toLowerCase() === 'active') && (
                      <Button
                        type="primary"
                        onClick={() =>
                          this.resumeOrder(
                            item.orderid,
                            item.status.toLowerCase()
                          )
                        }>
                        {item.status.toLowerCase() === 'pending'
                          ? 'Resume'
                          : 'Download'}
                      </Button>
                    ),
                  ]}>
                  <List.Item.Meta
                    title={item.title}
                    style={{ textTransform: 'capitalize', fontWeight: 600 }}
                    description={`STATUS: ${item.status}`}
                  />
                </List.Item>
              )}
            />
          )
        ) : (
          <h3 class="wple-api-down">
            API undergoing maintenance. Please check back after some time.
          </h3>
        )}
      </>
    );
  }
}

export default WPLE_Certpanel;
